import { render, staticRenderFns } from "./SalesProducts.vue?vue&type=template&id=67170096&scoped=true&"
import script from "./SalesProducts.vue?vue&type=script&lang=js&"
export * from "./SalesProducts.vue?vue&type=script&lang=js&"
import style0 from "./SalesProducts.vue?vue&type=style&index=0&id=67170096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67170096",
  null
  
)

export default component.exports